import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 300px;
`;

export const EditIconButton = styled.button`
  cursor: pointer;
  padding: 5px;
  transition:
    color,
    background-color 300ms ease;

  svg,
  path {
    transition:
      color,
      fill 300ms ease;
  }

  &:hover {
    svg path {
      fill: #000000;
    }

    svg.approve {
      color: green !important;
    }

    svg.reject {
      color: red !important;
    }
  }
`;

export const DefaultStateWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 5px;
  }

  ${EditIconButton} {
    visibility: hidden;
  }

  .settings-table-tr:hover & {
    ${EditIconButton} {
      visibility: visible;
    }
  }
`;

export const SelectingStateWrapper = styled.div`
  display: flex;
  align-items: center;

  button {
    margin-left: 5px;
  }
`;
